import { render, staticRenderFns } from "./taskstatistic.vue?vue&type=template&id=1f1bdf08&scoped=true&"
import script from "./taskstatistic.vue?vue&type=script&lang=js&"
export * from "./taskstatistic.vue?vue&type=script&lang=js&"
import style0 from "./taskstatistic.vue?vue&type=style&index=0&id=1f1bdf08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1bdf08",
  null
  
)

export default component.exports